import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import StatusPill from "../../Budgets/components/StatusPill";

/**
 * StatusBadgeBlock - overall verdict pill for the board report cover/summary.
 *
 * GET /api/v1/financial-control/summary -> { summary: { overall: { status } } }
 * status is financialcontrol.OverallStatus: "green" | "at_risk" | "over".
 * StatusPill already maps that exact vocabulary to On track/At risk/Over budget
 * (extended for this task - see src/views/Budgets/components/StatusPill.jsx).
 */
const StatusBadgeBlock = ({ title = "Status", period }) => {
  const { data, isLoading, error } = useBlockData("/api/v1/financial-control/summary", {
    params: period ? { period } : undefined,
  });

  const status = data?.summary?.overall?.status;

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error}>
      <StatusPill status={status} />
    </BaseBlock>
  );
};

StatusBadgeBlock.propTypes = {
  title: PropTypes.string,
  period: PropTypes.string,
};

export default StatusBadgeBlock;
